// extracted by mini-css-extract-plugin
export default {"title":"BT0ah2A4l7Utb+CUG3XxPw==","icon":"Aqs6pp0Lco0ss-MlBUFITA=="};